// extracted by mini-css-extract-plugin
export default {"tagsContent":"styles_tagsContent__gFRX2","tag":"styles_tag__2JUsn"};